import { CheckState } from './CheckState.enum';

export class Check {
    state: CheckState;
    nameDictionaryKey: string;
    descriptionDictionaryKey: string;
    key: string;

    constructor(check? : Partial<Check>) {
      if (check != null) {
        this.state = check.state;
        this.nameDictionaryKey = check.nameDictionaryKey;
        this.descriptionDictionaryKey = check.descriptionDictionaryKey;
        this.key = check.key;
      }
    }
}
